




import { mapGetters } from 'vuex';
import { Component, Vue } from 'vue-property-decorator';
import { Context } from '@nuxt/types';
import ContentfulPage from '~/api/contentful/page';
import { Entry } from '~/node_modules/contentful';

import { ProductSolutionCollection } from '~/types/Product';
import { PageType } from '~/types/Page';
import { setMetadataFromEntry } from '~/helpers/seo';
import { setMunicipalityCookie, setMunicipalityState } from '~/helpers/municipalityState';
import { cookieName } from '~/store/municipality';

import PageLayout from '~/patterns/organisms/page-layout/page-layout.vue';

import Alerts from '~/patterns/molecules/alerts.vue';
import ContentBlocks from '~/patterns/organisms/_collections/content-blocks/content-blocks.vue';
import GhHero from '~/patterns/organisms/gh-hero/gh-hero.vue';
import RichTextRenderer from '~/patterns/molecules/rich-text/rich-text.vue';

const EditButton = () => import(/* webpackPrefetch: true */ '~/patterns/molecules/edit-button.vue');

@Component({
    components: { PageLayout, ContentBlocks, Alerts, GhHero, RichTextRenderer, EditButton },

    computed: {
        ...mapGetters({ site: 'site/site' })
    },

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    asyncData(context: Context): Promise<void | { entry: Entry<any> }> {
        const { error, store } = context;
        setMunicipalityCookie(context);

        return new ContentfulPage()
            .getBySlug('energiebesparen', store.getters['site/site'])
            .then(entries => {
                if (entries.items.length === 0) {
                    error({ statusCode: 404, message: 'Pagina niet gevonden' });
                }
                return { entry: entries.items[0] };
            })
            .catch(() => {
                error({ statusCode: 500, message: 'Er ging iets mis' });
            });
    },

    head(this: Energiebesparen): object {
        // @ts-ignore
        const municipality = this.$cookies.get(cookieName);
        return setMetadataFromEntry(this.entry as PageType, this.$route, municipality);
    }
})
export default class Energiebesparen extends Vue {
    // Need to initialize as generic to get vue reactivity.
    entry: ProductSolutionCollection | object = {};

    // Need to initialize as generic to get vue reactivity.
    opportunities: object[] | null = null;

    solutions: object[] | null = null;

    snippetJson: boolean = false;

    site: string;

    get isMunicipalityPage(): boolean {
        return false;
    }

    get fields(): boolean {
        return false;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get hero(): Entry<any> {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (this.entry as Entry<any>).fields.hero;
    }

    get municipalityId(): string {
        return '';
    }

    get municipality() {
        return this.$store.getters['municipality/municipality'];
    }

    get footerImage(): undefined {
        return undefined;
    }

    async created() {
        // @ts-ignore
        await setMunicipalityState(this.$store, this.$cookies.get(cookieName));
    }
}
